import Vue from 'vue';
import Router from 'vue-router';
const About = () => import('./views/About.vue');
const AcceptQuote = () => import('./views/AcceptQuote.vue');
const Blog = () => import('./views/Blog.vue');
const BlogPost = () => import('./views/BlogPost.vue');
const Cart = () => import('./views/Cart.vue');
const Clinic = () => import('./views/Clinic.vue');
const Clinics = () => import('./views/Clinics.vue');
const ContactUs = () => import('./views/ContactUs.vue');
const CreateCampaign = () => import('./views/CreateCampaign.vue');
const Donate = () => import('./views/Donate.vue');
const Home = () => import('./views/Home.vue');
const Privacy = () => import('./views/Privacy.vue');
const Procedures = () => import('./views/Procedures.vue');
const Profile = () => import('./views/Profile.vue');
const Quote = () => import('./views/Quote.vue');
const ShowCampaign = () => import('./views/ShowCampaign.vue');
const Terms = () => import('./views/Terms.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/clinics',
      name: 'clinics',
      component: Clinics,
    },
    {
      path: '/procedures',
      name: 'procedures',
      component: Procedures,
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
    },
    {
      path: '/clinic',
      name: 'clinic',
      component: Clinic,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/quote',
      name: 'quote',
      component: Quote,
    },
    {
      path: '/acceptQuote',
      name: 'acceptQuote',
      component: AcceptQuote,
    },
    {
      path: '/createCampaign',
      name: 'createCampaign',
      component: CreateCampaign,
    },
    {
      path: '/showCampaign',
      name: 'showCampaign',
      component: ShowCampaign,
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },
    {
      path: '/donate',
      name: 'donate',
      component: Donate,
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs,
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog,
    },
    {
      path: '/blog/:id',
      name: 'blogPost',
      component: BlogPost,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
